import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {Helmet} from 'react-helmet';
import LocalizedStrings from 'react-localization';

const Wrapper = (props) => {
  const { children, locale } = props;
  const { pathname, search } = useLocation();
  const history = useHistory();
  const strings = new LocalizedStrings({
    ru: {
      docTitle: "КАСКО для Авто - Онлайн Расчет - Polis.Ua",
      metaDescr: "Рассчитывайте стоимость ✅ КАСКО ✅ онлайн за 3 минуты. ⭐ Только надежные страховые компании по КАСКО собраны на Polis.ua. ⭐ Онлайн поддержка 24/7. Быстрые страховые  выплаты при ДТП, Тотале, Угоне. ⭐ Скидки на все виды КАСКО. 📞 (044) 585-25-77",
    },
    ua: {
      docTitle: "КАСКО для Авто - Онлайн Розрахунок - Polis.Ua",
      metaDescr: "Розраховуйте вартість ✅ КАСКО ✅  онлайн за 3 хвилини. ⭐ Тільки надійні страхові компанії по КАСКО зібрані на Polis.ua. ⭐ Онлайн підтримка 24/7. Гнучкі ціни та знижки, швидкі виплати при ДТП, Тотал, Викрадення. ⭐ Знижки на всі види КАСКО.  📞 (044) 585-25-77",
    },
  });
  strings.setLanguage(locale);
  const isRootUrl = pathname === '/kasko'
    || pathname === '/kasko/'
    || pathname === '/uk/kasko'
    || pathname === '/uk/kasko/';

  useEffect(() => {
    window.fbq('track', 'PageView');
  }, [pathname]);

  useEffect(() => {
    let path;

    if (locale === 'ua' && !pathname.includes('/uk/')) {
      path = pathname.replace('/', '/uk/') + search;
      history.push(path);
    } else if (locale === 'ru' && pathname.includes('/uk/')) {
      path = pathname.replace('/uk/', '/') + search;
      history.push(path);
    }
  }, [locale]);

  return (
    <div id="wrapper">
      { children }
      <Helmet
        htmlAttributes={{"lang": locale === 'ua' ? 'uk' : 'ru'}}
        title={strings.docTitle}
        meta={isRootUrl ? [
          { name: 'description', content: strings.metaDescr, lang: locale === 'ua' ? 'uk' : 'ru' },
        ] : undefined}
        link={locale === 'ua'
          ? [
            { rel: 'canonical', href: 'https://polis.ua/uk/kasko' },
            { rel: 'alternate', href: 'https://polis.ua/kasko', hreflang: 'ru' },
            { rel: 'alternate', href: 'https://polis.ua/uk/kasko', hreflang: 'uk' },
          ]
          : [
            { rel: 'canonical', href: 'https://polis.ua/kasko' },
            { rel: 'alternate', href: 'https://polis.ua/kasko', hreflang: 'ru' },
            { rel: 'alternate', href: 'https://polis.ua/uk/kasko', hreflang: 'uk' },
          ]}
      />
    </div>
  );
};

export default Wrapper;
